/* eslint-disable @typescript-eslint/no-explicit-any */
import { Grid, debounce } from '@mui/material'
import { Button, DropdownField, TextField } from 'shared/components'
import { SelectOption } from 'shared/components/SelectField'
import { ProductRequestModel } from 'types/products'

type StatusOption = SelectOption<number>

const options: StatusOption[] = [
  {
    label: 'Không tích tem',
    value: 0,
    key: 'allowed',
  },
  {
    label: 'Được tích tem',
    value: 1,
    key: 'not-allowed',
  },
]

interface ProductFilterProps {
  onFilterChange: (f: ProductRequestModel) => void
  filter: ProductRequestModel
  onButtonClick: () => void
  onSyncData: () => void
  isSyncData?: boolean
}

const ProductFilter = ({
  filter,
  onFilterChange,
  onButtonClick,
  onSyncData,
  isSyncData = false,
}: ProductFilterProps) => {
  const handleSearchTextChange = debounce(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      onFilterChange({ ...filter, searchValue: e.target.value })
    },
    500
  )

  const handleStatusChange = (_e: any, val: StatusOption) => {
    const value = !val || val === null ? -1 : val.value
    onFilterChange({ ...filter, allowChangeTem: value })
  }

  return (
    <Grid container alignItems="end" gap={2}>
      <Grid item width={250}>
        <TextField
          onChange={handleSearchTextChange}
          label="Tìm kiếm"
          fullWidth
        />
      </Grid>
      <Grid item width={250}>
        <DropdownField
          onChange={handleStatusChange}
          label="Trạng thái"
          fullWidth
          options={options}
        />
      </Grid>
      <Grid item>
        <Button
          disabled={isSyncData}
          loading={isSyncData}
          width={160}
          onClick={onSyncData}
        >
          Đồng bộ dữ liệu
        </Button>
      </Grid>
      <Grid item>
        <Button onClick={onButtonClick} width="auto">
          Thêm sản phẩm không cho phép tích tem
        </Button>
      </Grid>
    </Grid>
  )
}

export default ProductFilter
